export default "__VITE_ASSET__B3Ho0OGN__"